import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const setNewReserveSubmittedNotification = message => {
  return {
    type: actionTypes.NEW_RESERVE_SUBMITTED_NOTIFICATION,
    payload: {
      message,
    },
  };
};

export const setReserveRequestsAutomaticallyApprovedNotification = data => {
  return {
    type: actionTypes.RESERVEـREQUESTS_AUTOMATICALLY_APPROVED_NOTIFICATION,
    payload: data,
  };
};

export const getMyUnreadNotification = () => {
  return dispatch => {
    dispatch(action(actionTypes.GET_MY_UNREAD_NOTIFICATION_LOADING));
    return API.notification
      .getMyUnreadNotification()
      .then(res =>
        dispatch(action(actionTypes.GET_MY_UNREAD_NOTIFICATION_SUCCESS, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_MY_UNREAD_NOTIFICATION_FAILED,
            reject: actionTypes.GET_MY_UNREAD_NOTIFICATION_REJECT,
          }),
        );
        throw err;
      });
  };
};

export const putMyReadNotification = cafeIds => {
  return dispatch => {
    dispatch(action(actionTypes.PUT_READ_NOTIFICATION_LOADING));
    return API.notification
      .putMyReadNotification(cafeIds)
      .then(res =>
        dispatch(action(actionTypes.PUT_READ_NOTIFICATION_SUCCESS, res)),
      )
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_MY_UNREAD_NOTIFICATION_FAILED,
            reject: actionTypes.GET_MY_UNREAD_NOTIFICATION_REJECT,
          }),
        );
        throw err;
      });
  };
};

export const updateSocketReserve = data => {
  return {
    type: actionTypes.UPDATE_SOCKET_RESERVE,
    payload: data,
  };
};


export const printRequestTablet = data => {
  return {
    type: actionTypes.PRINT_REQUEST_TABLET,
    payload: data,
  };
};
